import React from 'react'
import { useTheme } from 'styled-components'
import { Info, IconProps } from 'react-feather'
import { TooltipProps } from '@mui/material/Tooltip'
import { Tooltip } from '../Tooltip'

type TooltipPlacement = Pick<TooltipProps, 'placement' | 'title'> & { title: React.ReactNode }

interface InfoIconProps {
  tooltipProps: TooltipPlacement
  iconProps?: IconProps
}

const InfoIcon: React.FC<InfoIconProps> = ({ iconProps, tooltipProps }) => {
  const theme = useTheme()

  return (
    <Tooltip {...{ ...tooltipProps }}>
      <Info cursor="pointer" color={theme.colors.gray6} size={24} {...iconProps} />
    </Tooltip>
  )
}

export default InfoIcon
